<template>
    <div class="accordion-group accordion-local">
        <div class="accordion accordion--desktop"  v-for="(accordion, index) in content">
            <div class="accordion-title accordion-title--desktop collapsed text-uppercase"
                 data-toggle="collapse"
                 :data-target="`#${prefix}-${index}`"
                 :aria-controls="`${prefix}-${index}`"
            >  {{ accordion.title }}
            </div>

            <div class="accordion-content accordion-content--desktop collapse flex-grow-1"
                 :id="`${prefix}-${index}`">
                <img v-if="accordion.image"
                     :src="accordion.image.src" alt=""
                     :width="accordion.image.width ? accordion.image.width : '100%'"/>
                <span class="text-align-left" v-html="accordion.content"/>
            </div>
        </div>
    </div>
</template>

<script>
const data = () => {
    return {
        activeIndex: Array,

    }
};

export default {
    props: {
        content: {
            type: Array | Object
        },
        prefix: {
            type: String
        }
    },
    data
}
</script>
